export default "__VITE_ASSET__BjT3IUC$__"